import {Button} from '@continuum/ui';

interface ErrorScreenProps {
  title?: string;
  message?: string;
  showRefresh?: boolean;
}

export const ErrorScreen = ({
  title = 'Something went wrong',
  message = "We're sorry, but something unexpected happened.",
  showRefresh = false,
}: ErrorScreenProps) => {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="max-w-md px-4 text-center">
        <h1 className="text-2xl font-semibold text-foreground">{title}</h1>
        <p className="mt-2 text-sm text-muted-foreground">{message}</p>

        {showRefresh && (
          <Button onClick={() => window.location.reload()} className="mt-6">
            Refresh page
          </Button>
        )}
      </div>
    </div>
  );
};
